import { createNoise2D, type NoiseFunction2D } from "simplex-noise"
import { createNewRNGConfig, next } from "./index"

export default function createSeededNoise2D(seed: number): NoiseFunction2D {
  const rng = createNewRNGConfig()
  rng.seed = rng.state = seed
  const noise2D = createNoise2D(() => next(rng))
  return noise2D
}